import { useEffect } from "react"
import siteConfig from "config"

const useTitle = (title?: string, description?: string) => {

    useEffect(() => {
        if (!title) return
        const prev = document.title
        const fullTitle = `${title} | ${siteConfig.siteTitle}`
        document.title = fullTitle
        document.querySelector('meta[property="og:title"]')?.setAttribute('content', fullTitle)
        return () => {
            document.title = prev
        }
    }, [title])

    useEffect(() => {
        if (!description) return
        const descMeta = document.querySelector('meta[name="description"]')
        const ogDescMeta = document.querySelector('meta[property="og:description"]')
        const prev = descMeta?.getAttribute('content')!
        descMeta?.setAttribute('content', description)
        ogDescMeta?.setAttribute('content', description)
        return () => {
            descMeta?.setAttribute('content', prev)
            ogDescMeta?.setAttribute('content', prev)
        }
    }, [description])

    useEffect(() => {
        const canonical = document.querySelector('link[rel="canonical"]')
        if (canonical) {
            canonical.setAttribute('href', siteConfig.siteUrl + window.location.pathname)
        }
    })
}

export default useTitle
